import { css, CSSResult } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { csBorder } from '@cloudsuite/mosaic-shared/styles/globals.style.js'
import { csColorBorder } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { SCREENS } from '@cloudsuite/mosaic-shared/styles/breakpoints.js'


export const cscDisplayOptionsToolbar = {
  paddingBlockMobile: css`var(--csc-display-options-toolbar-padding-y-mobile, ${csSpacing.spacing05})`,
  paddingInline: css`var(--csc-display-options-toolbar-padding-x, 0)`,
  paddingBlock: css`var(--csc-display-options-toolbar-padding-y, ${csSpacing.spacing05})`,
  borderBlockWidthMobile: css`var(--csc-display-options-toolbar-border-block-width, 0 ${csBorder.width})`,
  borderBlockWidth: css`var(--csc-display-options-toolbar-border-block-width, ${csBorder.width})`,
  borderInlineWidth: css`var(--csc-display-options-toolbar-border-inline-width, 0)`,
  borderColor: css`var(--csc-display-options-toolbar-border-color, ${csColorBorder.light})`,
  columnGap: css`var(--csc-display-options-toolbar-column-gap, ${csSpacing.spacing06})`,
}

export const style: CSSResult = css`
  cse-skeleton {
    display: block;
  }

  .csc-display-options-toolbar {
    border-color: ${cscDisplayOptionsToolbar.borderColor};
    border-style: solid;
    border-inline-width: ${cscDisplayOptionsToolbar.borderInlineWidth};
    border-block-width: ${cscDisplayOptionsToolbar.borderBlockWidthMobile};
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    column-gap: ${cscDisplayOptionsToolbar.columnGap};

    @media(min-width: ${SCREENS.medium}) {
      padding-block: ${cscDisplayOptionsToolbar.paddingBlock};
      padding-inline: ${cscDisplayOptionsToolbar.paddingInline};
      flex-direction: row;
      align-items: center;
      border-block-width: ${cscDisplayOptionsToolbar.borderBlockWidth};
    }
  }

  .options {
    display: flex;
    column-gap: ${cscDisplayOptionsToolbar.columnGap};
    border-top: ${csBorder.width} solid ${cscDisplayOptionsToolbar.borderColor};
    padding-block: ${cscDisplayOptionsToolbar.paddingBlockMobile};
    align-items: baseline;
    justify-content: space-between;

    @media(min-width: ${SCREENS.medium}) {
      border-top: none;
      padding-block: 0;
      justify-content: flex-start;
    }
  }

  .title {
    padding-bottom: ${cscDisplayOptionsToolbar.paddingBlockMobile};

    @media(min-width: ${SCREENS.medium}) {
      padding-bottom: 0;
    }
  }
`
